// extracted by mini-css-extract-plugin
export default {"item":"VGg6meSmUJd7GV8QaCCd"};